/* global axios */
import ApiClient from './ApiClient';

class PhoneSettingsAPI extends ApiClient {
  constructor() {
    super('phone_settings', { accountScoped: true });
  }

  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/phone_settings`);
  }

  update(accountId, settings) {
    return axios.patch(`/api/v1/accounts/${accountId}/phone_settings`, {
      settings,
    });
  }

  // Calls waiting to be answered, polled from every open tab so an
  // incoming call can be announced wherever the agent is.
  ringing(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/phone_settings/ringing`
    );
  }

  // Live open/closed state, so the page can show what callers get right now.
  // Numbers on the Telnyx account, for the outbound-number import.
  telnyxNumbers(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/phone_settings/telnyx_numbers`
    );
  }

  status(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/phone_settings/status`);
  }
}

export default new PhoneSettingsAPI();
